import React from "react";
import styled from "styled-components";
import WSDCover from "./../assets/img/wsd_cover.png";
import { transitionMixin, flexCenter, flexColumn } from "../components/mixins";
import Button from "./../components/Button/Button.component";

const CoverFloating = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(30px, -40%);
    width: 150px;
    z-index: -1;
    cursor: pointer;
    ${transitionMixin()};

    p {
        font-size: ${({ theme }) => theme.fz.XXXS};
        font-weight: ${({ theme }) => theme.fw.semiBold};
        font-family: ${({ theme }) => theme.ff.Tomica};
        letter-spacing: 1px;
        text-transform: uppercase;
        margin-bottom: 5px;
    }

    & img {
        max-width: 180px;
        object-fit: contain;
    }

    &:hover {
        transform: translate(30px, -45%);
    }

    @media screen and (max-width: 1250px) {
        transform: translate(-50px, -40%);

        &:hover {
            transform: translate(-50px, -45%);
        }
    }

    @media screen and (max-width: 1050px) {
        display: none;
    }
`;

const SubMenuFloating = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 11;
    display: grid;
    grid-template-columns: 1fr 1fr;
    visibility: hidden;
    opacity: 0;
    width: 500px;
    min-height: 290px;
    padding: 10px 0;
    border-top: 2px solid ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.white};
    transition: visibility 0s, all 0.3s;
    box-shadow: 5px 5px 10px -5px ${({ theme }) => theme.colors.black};

    &:hover {
        visibility: visible;
        opacity: 1;
    }

    @media screen and (max-width: 1050px) {
        display: none;
    }
`;

const Container = styled.div`
    & ${CoverFloating}:hover ~ ${SubMenuFloating} {
        visibility: visible;
        opacity: 1;
    }
`;

const Submenu = styled.nav`
    width: 100%;
    padding: 20px 0 20px 20px;
    ${flexCenter};
    ${flexColumn};
    justify-content: flex-start;
    align-items: flex-start;

    p {
        line-height: 140%;
    }

    /* a {
        width: 100%;
        padding: 0 0 10px;
        margin: 5px 0;
        font-size: ${({ theme }) => theme.fz.XXXS};
        font-family: ${({ theme }) => theme.ff.Montserrat};
        font-weight: ${({ theme }) => theme.fw.semiBold};
        color: ${({ theme }) => theme.colors.black};
        ${transitionMixin()};
        letter-spacing: 1.5px;
        text-decoration: none;
        text-transform: uppercase;
        border-bottom: 1px solid ${({ theme }) => theme.colors.light_grey2};

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            color: ${({ theme }) => theme.colors.grey};
        }
    } */

    & > * {
        margin-bottom: 10px;
    }
`;

const CurrentNumberContainer = styled.div`
    padding: 15px;
    ${flexCenter};
    ${flexColumn};
    justify-content: flex-start;
    text-align: center;

    img {
        max-width: 180px;
    }

    a {
        text-decoration: none;
        p {
            text-decoration: none;
            color: ${({ theme }) => theme.colors.black};
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
        text-decoration: underline;
    }

    & > * {
        margin-bottom: 15px;
    }
`;

const FloatingCoverWithSubMenu = (props) => (
    <Container>
        <CoverFloating>
            <p className="uppercase">Patronat merytoryczny</p>
            <picture>
                <img
                    src={WSDCover}
                    alt="Okładka Współczesna Dietetyka - bieżący numer"
                />
            </picture>
        </CoverFloating>
        <SubMenuFloating>
            <Submenu>
                <h6>Patronat merytoryczny</h6>
                <p>
                    Nad jakością merytoryczną zawartości magazynu czuwa Redakcja
                    czasopisma Współczesna Dietetyka.
                </p>
            </Submenu>
            <CurrentNumberContainer>
                <a href="https://www.wspolczesnadietetyka.pl/">
                    <picture>
                        <img
                            src={WSDCover}
                            alt="Okładka Współczesna dietetyka"
                        />
                    </picture>
                </a>
                <a href="https://www.wspolczesnadietetyka.pl/">
                    <p>Zobacz więcej...</p>
                </a>
            </CurrentNumberContainer>
        </SubMenuFloating>
    </Container>
);
export default FloatingCoverWithSubMenu;
